const TranRoutesIcon = () => {
  return (
    <svg
      className="header_icon"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="white" />
      <path
        className="fill"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1512 26.7508C24.0862 24.1124 26 21.682 26 18.7303C26 15.5655 23.5376 13 20.5 13C17.4624 13 15 15.5655 15 18.7303C15 21.682 16.9138 24.1124 19.8488 26.7508C20.2192 27.0838 20.7808 27.0838 21.1512 26.7508ZM20.5 20.5C21.6046 20.5 22.5 19.6046 22.5 18.5C22.5 17.3954 21.6046 16.5 20.5 16.5C19.3954 16.5 18.5 17.3954 18.5 18.5C18.5 19.6046 19.3954 20.5 20.5 20.5Z"
        fill="#17171C"
      />
      <path
        className="fill"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 26C25 25.4477 25.4477 25 26 25H30C31.6569 25 33 26.3431 33 28C33 29.6569 31.6569 31 30 31H18C17.4477 31 17 31.4477 17 32C17 32.5523 17.4477 33 18 33H26C26.5523 33 27 33.4477 27 34C27 34.5523 26.5523 35 26 35H18C16.3431 35 15 33.6569 15 32C15 30.3431 16.3431 29 18 29H30C30.5523 29 31 28.5523 31 28C31 27.4477 30.5523 27 30 27H26C25.4477 27 25 26.5523 25 26Z"
        fill="#17171C"
      />
    </svg>
  )
}

export default TranRoutesIcon
